import React, { useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector, } from "react-redux";
// New import
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useCreate, useGetOne, useNotify, useRefresh } from "react-admin";
import debouce from "lodash.debounce";
import SsnSection from "./SsnSection";
import { RootState } from "../../../Store/store";
import { useUserRole } from "../../../ContextApi/UserRoleContext";

const SsnAccordion = forwardRef((props: any, ref) => {

  const submitBtnRef = useRef<HTMLButtonElement>(null);

  const refresh = useRefresh();
  const notify = useNotify();
  const [create, { isLoading, error }] = useCreate();
  const saveIdDetails = (payload: any) => {
    return create(
      "saveiddetail",
      { data: payload },
      {
        onSuccess: (data) => {
          notify(`Request processed successfully.`, { type: "success", anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          refresh();
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, { type: "error", anchorOrigin: { vertical: 'top', horizontal: 'right' } }),
      }
    );
  };
  const trn_id = props.Trnid;

  // get Identification Data
  const { data: getIdentificationData, isLoading: isLoadingData } = useGetOne(
    "ssnGetidentification",
    {
      id: trn_id,
    }, {
    refetchOnWindowFocus: false
  }
  );


  const validateSSNFormates = (ssnNo, path, createError, myFailureMessage) => {
    switch (ssnNo) {
      case "111-11-1111":

        return createError({ path, message: myFailureMessage });
      case "222-22-2222":

        return createError({ path, message: myFailureMessage });
      case "333-33-3333":

        return createError({ path, message: myFailureMessage });
      case "444-44-4444":

        return createError({ path, message: myFailureMessage });
      case "555-55-5555":

        return createError({ path, message: myFailureMessage });
      case "666-66-6666":

        return createError({ path, message: myFailureMessage });
      case "777-77-7777":

        return createError({ path, message: myFailureMessage });
      case "888-88-8888":

        return createError({ path, message: myFailureMessage });
      case "999-99-9999":

        return createError({ path, message: myFailureMessage });
      case "123-45-6789":

        return createError({ path, message: myFailureMessage });
      default:
        return true;
    }
  };

  const ssn_data_schema = yup.object().shape({
    isUS_citizen: yup.string().nullable(),
    SSNNumber: yup
      .string()
      .nullable()
      .when("isUS_citizen", {
        is: (value) => {
          return value === "Yes";
        },
        then: yup
          .string()
          .typeError("required")
          .required("required")
          .matches(/^(?!666|000|9\d{2})(\d{3})(-?)(?!00)\d{2}\2(?!0{4})\d{4}$/, 'Please Enter valid SSN Number')
          .test("validate-ssn", function (value) {
            const { path, createError } = this;
            const myFailureMessage = "Please Enter valid SSN Number";
            if (value) {
              return validateSSNFormates(
                value,
                path,
                createError,
                myFailureMessage
              );
            }
          }),
      }),
    availableToUpload_ssn: yup
      .string()
      .typeError("required")
      .required("required"),
    file: yup
      .string()
      .nullable()
      .typeError("front file required")
      .when("availableToUpload_ssn", {
        is: (value) => {
          return value == "Yes";
        },
        then: yup
          .string()
          .typeError("SSN file is required")
          .required("SSN file is required"),
      }),
    other_reason: yup.string().when("no_doc_reason", {
      is: (value) => {
        return value == "other";
      },
      then: yup.string().typeError("required").required("Required")
        .matches(/^$|^\S+.*/g, "Enter a valid value"),
      otherwise: yup.string().nullable(),
    }),
  });
  const { role } = useUserRole();

  const userRoleRedux = useSelector((state: RootState) => state?.users?.role);
  const userRole = role || userRoleRedux;
  const schema = yup.object().shape({
    ssn_data: ssn_data_schema
  });

  const getSchema = () => {
    return schema;
  };

  const methods = useForm({
    resolver: yupResolver(getSchema()),
    mode: "onChange",
  });

  useEffect(() => {
    const data_form_value = methods.getValues();
    const api_data = getIdentificationData?.data;
    if (Object.keys(data_form_value)?.length) {
      const mapData = {
        ...api_data,
        ssn_data: {
          ...api_data?.ssn_data,
          SSNNumber: !data_form_value?.ssn_data.SSNNumber
            ? api_data?.ssn_data?.SSNNumber
            : data_form_value?.ssn_data?.SSNNumber,
          isUS_citizen: !data_form_value?.ssn_data?.isUS_citizen
            ? api_data?.ssn_data?.isUS_citizen
            : data_form_value?.ssn_data?.isUS_citizen,
          availableToUpload_ssn: !data_form_value?.ssn_data?.availableToUpload_ssn
            ? api_data?.ssn_data?.availableToUpload_ssn
            : data_form_value?.ssn_data?.availableToUpload_ssn,
        },
      };
      methods.reset(mapData);
    } else {
      methods.reset(api_data);
    }
  }, [getIdentificationData?.data, methods]);

  const onSubmitDetails = async (fromData) => {

    if (fromData?.ssn_data?.no_doc_reason === "other") {
      fromData.ssn_data.no_doc_reason = fromData?.ssn_data?.other_reason;
    }
    const payload = {
      trn_id,
      ...fromData,
    };
    saveIdDetails(payload);
  };

  const onSubmit = async (fromData) => {
    const postData = {
      ...fromData,
      ssn_data: {
        ...fromData?.ssn_data,
        other_reason: fromData?.ssn_data?.availableToUpload_ssn == "No" && fromData?.ssn_data?.no_doc_reason == "other" ? fromData?.ssn_data?.other_reason : null,
      }
    }
    onSubmitDetails(postData);
  };

  //  new states
  const [expandIdSection, setExpandIdSection] = React.useState(true);

  const handleSubmitManual = () => {
    submitBtnRef?.current?.click();
  };
  const handleAPIDebounced = useMemo(() => {
    return debouce(handleSubmitManual, 3000);
  }, []);

  async function handleClickByRef() {
    submitBtnRef?.current?.click();
    const isValidForm = await methods?.trigger();
    return isValidForm;
  }

  useImperativeHandle(ref, () => ({ handleClickByRef, handleSubmitManual }));

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <fieldset>
          <div className="info-toggle">
            <div className="toggle-heads">
              <div className="row align-items-center justify-content-between ">
                <div className="col">
                  <div className="d-flex align-items-center">
                    <b className="ms-3 me-2">Social Security Number</b>
                  </div>
                </div>

                <div className="col text-end m-1">
                  <IconButton
                    className="print-hide"
                    onClick={() => setExpandIdSection((v) => !v)}
                    color="primary"
                  >
                    {!expandIdSection ? <AddIcon /> : <RemoveIcon />}
                  </IconButton>
                </div>
              </div>

              <div
                className={` ${!expandIdSection ? "d-none" : "d-display"
                  } card-body cust-card-appl`}
              >
                <div
                  className="card card-body w-100"
                  style={{ paddingTop: 0 }}
                >
                  <>
                    <SsnSection required={props?.required} Trnid={props?.Trnid} handleAPIDebounced={handleAPIDebounced} />
                    <button
                      type="submit"
                      ref={submitBtnRef}
                      className="d-none"
                    >
                      submit
                    </button>
                    <div className="d-flex flex-wrap justify-content-between pb-2 print-hide">
                      {userRole !== 'applicant' && <button
                        type="submit"
                        className="btn btn-primary print-hide"
                        style={{
                          backgroundColor: "#2dc3e8",
                          fontFamily: "OpenSans-Bold",
                          color: "white",
                          marginLeft: 18,
                          padding: "8px 15px 8px 15px",
                        }}
                      >
                        {" "}
                        Save
                      </button>}
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </FormProvider>
  )
})

export default SsnAccordion
